import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import type { OptionalQueryOptions, QueryApiOptions } from '../../types/types';
import { AuthUserinfoResponse } from '@as-react/common-types';
import { getUserinfo, logout, OAuthLogoutParams } from './auth.api';

export const authQueryKeys = {
  all: () => ['auth'] as QueryKey,
  getUserinfo: () => [...authQueryKeys.all(), 'userinfo'] as QueryKey,
  logout: () => [...authQueryKeys.all(), 'logout'] as QueryKey,
};

export const authQueries = (apiOptions: QueryApiOptions) => ({
  getUserinfo: <TReturnData = AuthUserinfoResponse>(
    options: OptionalQueryOptions<AuthUserinfoResponse, TReturnData> = {}
  ): UseQueryOptions<AuthUserinfoResponse, Error, TReturnData> => ({
    ...options,
    queryKey: authQueryKeys.getUserinfo(),
    queryFn: () => getUserinfo(apiOptions),
  }),
  logout: <TReturnData = unknown>(
    params: OAuthLogoutParams,
    options: OptionalQueryOptions<unknown, TReturnData> = {}
  ): UseQueryOptions<unknown, Error, TReturnData> => ({
    ...options,
    queryKey: authQueryKeys.logout(),
    queryFn: () => logout(apiOptions, params),
  }),
});
